import { FacilityLunchType } from '../entites/FacilityInfo'

export const getLunchTypeLabel = (type: FacilityLunchType): string => {
  if (type === 'unavailable') return '持参'
  else if (type === 'free_and_allergy_ok')
    return '無料で利用可（⭕ アレルギー対応あり）'
  else if (type === 'free_and_allergy_ng')
    return '無料で利用可（❌ アレルギー対応はできません）'
  else if (type === 'non_free_and_allergy_ok')
    return '有料で利用可（⭕ アレルギー対応あり）'
  else if (type === 'non_free_and_allergy_ng')
    return '有料で利用可（❌ アレルギー対応はできません）'
  else if (type === 'to_be_confirmed')
    return '有料と無料のものがあるため、オプションをご確認ください'
  return ''
}
